import { Entity } from "../../helpers/Entity"
import { Metadata } from "../metadata"

export enum PayinStatus {
    CREATED = "CREATED",
    PRESENTING = "PRESENTING",
    PROCESSING = "PROCESSING",
    APPROVED = "APPROVED",
    CANCELED = "CANCELED",
    FAILED = "FAILED",
}

export type PayinConfigDto = {
    payinConfigId: string
    is3DSRequested: boolean
    metaData: Metadata
}

export class PayinConfig implements Entity{
    dto: PayinConfigDto

    constructor(dto: PayinConfigDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return !!this.dto
    }

    getId(): string {
        return this.dto.payinConfigId
    }

    is3DSRequested(): boolean {
        return this.dto.is3DSRequested
    }
}

export type PayinDto = {
    payinId: string,
    payinconfigId: string,
    merchantId: string,
    status: PayinStatus,
    refusalDesc: string,
}

export class Payin implements Entity{
    dto: PayinDto

    constructor(dto: PayinDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return !!this.dto
    }

    getId(): string {
        return this.dto.payinId
    }

    getStatus(): PayinStatus {
        return this.dto.status
    }

    getRefusalDesc(): string {
        return this.dto.refusalDesc
    }

    getPayinConfigId(): string {
        return this.dto.payinconfigId
    }
}


// WEBPACK FOOTER //
// ./src/state/payment-processor/rainforest/Payin.ts